let store = {}

export default function(context) {
  store = context.store
}

export function getStore() {
  return store
}
